import React, { useState } from "react";
import styled from "styled-components";
import OtpInput from "react-otp-input";
import axios from "axios";
// import axios from "axios";

const PinDialog = ({ onClose }) => {
  const [otp, setOtp] = useState("");
  const [error, setError] = useState(undefined);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.length < 6) {
      setError("Please Enter Valid OTP!");
      return;
    }
    try {
      const response = await axios.post("https://lw-lottery-api-twkwng2veq-em.a.run.app/api/tenant/3/access-pin/validate-pin", {
        data: { pin: otp }
      })
      if (response.data) {
        if (response.data?.success === true) {
          onClose();
        } else {
          alert(response.data?.message || "Invalid Pin")
        }
      } else {
        alert("Oops, Invalid Pin")
      }
    } catch (error) {
      console.log(error);
      alert("Invalid Pin, Try Again Later !")
    }
  };

  return (
    <Wrapper>
      <div className="content">
        <div className="header">Enter OTP</div>
        <form onSubmit={handleSubmit}>
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span>-</span>}
            inputStyle={{
              width: "20px",
              height: "20px",
              fontSize: "16px",
              padding: "10px",
              margin: "0px 3px",
              borderRadius: "8px",
            }}
            renderInput={(props) => <input {...props} type="number" />}
          />
          {error && <div className="error">{error}</div>}
          <button className="submit" type="submit">
            SUBMIT
          </button>
        </form>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    background: white;
    padding: 6px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: auto;
    text-align: center;
  }

  .error {
    font-size: 14px;
    color: red;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 12px 6px;
    font-weight: 600;
    font-size: 21px;
  }

  .submit {
    margin-top: 20px;
    padding: 10px 20px;
    border: none;
    background-color: #007bff;
    color: white;
    border-radius: 4px;
    cursor: pointer;
    float: right;
    font-size: 16px;
  }
`;

export default PinDialog;
